import { render } from "./CreateGroup.vue?vue&type=template&id=240a6792&scoped=true&ts=true"
import script from "./CreateGroup.vue?vue&type=script&lang=ts"
export * from "./CreateGroup.vue?vue&type=script&lang=ts"

import "./CreateGroup.vue?vue&type=style&index=0&id=240a6792&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240a6792"]])

export default __exports__